import type { ParagraphTwoPaths as ParagraphTwoPathsData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import styles from "./ParagraphTwoPaths.module.css";

/**
 * Layout 43 - `PARAGRAPH_TWO_PATHS_LAYOUT`: two paths (2 karty porownawcze).
 *
 * Struktura:
 *   - Eyebrow (text_1) - uppercase accent label (np. "WYBIERZ SWOJĄ ŚCIEŻKĘ")
 *   - H2 (name) - tytul sekcji (np. "Zbudujemy nowy sklep lub przeniesiemy Twoj obecny")
 *   - Grid 2-kol z 2 kart porownawczych:
 *       - Ikona (Nucleo, w boxie top-left karty)
 *       - Nazwa/tytul karty (H3)
 *       - Opis karty (paragraph)
 *   - Puste sloty (bez name i desc) filtrowane po backendzie
 */
export function ParagraphTwoPaths({
  paragraph,
}: {
  paragraph: ParagraphTwoPathsData;
  t: ParagraphTranslations;
}) {
  const { text_1: eyebrow, name: title, cards } = paragraph;
  const hasEyebrow = eyebrow && eyebrow.trim() !== "";
  const hasCards = Array.isArray(cards) && cards.length > 0;

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        {hasEyebrow ? <p className={styles.eyebrow}>{eyebrow}</p> : null}
        {title ? <h2 className={styles.title}>{title}</h2> : null}
      </div>
      {hasCards ? (
        <div className={styles.grid}>
          {cards.map((card, idx) => (
            <div key={idx} className={styles.card}>
              <div className={styles.cardHeader}>
                {card.icon ? (
                  <div className={styles.iconBox} aria-hidden="true">
                    <i className={`nc-icon-outline ${card.icon}`} />
                  </div>
                ) : null}
                {card.name ? <h3 className={styles.name}>{card.name}</h3> : null}
              </div>
              {card.desc ? <p className={styles.desc}>{card.desc}</p> : null}
            </div>
          ))}
        </div>
      ) : null}
    </section>
  );
}
